<template>
  <div>
    <back-btn />
    <v-container>
      <v-row>
        <v-col cols="12">
          <vlu-form @emitData="createVolunteer" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VluForm from "@/components/volunteer/VluForm";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    VluForm,
    BackBtn,
  },
  data: () => ({}),
  methods: {
    createVolunteer(payload) {
      this.$store.dispatch("Volunteer/createVolunteer", payload).then(() => {
        this.$router.push("/volunteer");
      });
    },
  },
};
</script>
